import { useQuery } from "react-query";

import { searchService } from "services";

type UseAgentOfficeSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useAgentOfficeSearchQuery = ({
	pattern,
	page,
	options,
}: UseAgentOfficeSearchQueryProps) =>
	useQuery(
		["agentOfficesSearch", pattern, page],
		() =>
			searchService.getAgentOffices({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useAgentOfficeSearchQuery;
